import { connect } from 'react-redux'

import { ChefMaster } from '@components/chef'

import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { AppState } from '@models'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state: AppState) => {
  const { chefs, router, user } = state
  const { id: userId, lastLoggedInHq } = user

  return { chefs, location: router.location, userId, lastLoggedInHq }
}

const mapDispatchToProps = () => {
  const {
    ChefService,
    CoreService,
    HeadquarterService,
    RestService,
    RouterService,
    SessionService,
    UIService,
  } = services
  const {
    pResponseChefs,
    pResponseChef,
    pResponseHeadquarters,
    pResponseUser,
  } = presenters.Api
  const { ChangeHeadquarter, LoadChefs, LoadCuisineTags, SelectChef } =
    coordinators

  const changeHeadquarter = ChangeHeadquarter({
    CoreService,
    HeadquarterService,
    RestService,
    RouterService,
    SessionService,
    UIService,
    pResponseHeadquarters,
    pResponseUser,
    HandleError,
  })
  const loadChefs = LoadChefs({ ChefService, RestService, pResponseChefs })
  const selectChef = SelectChef({ ChefService, RestService, pResponseChef })
  const loadCuisineTags = LoadCuisineTags({ RestService, HandleError })

  return {
    changeHeadquarter,
    loadChefs,
    loadCuisineTags,
    selectChef,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChefMaster)
